// extracted by mini-css-extract-plugin
export var active = "MobileLinkCarousel-module--active--74248";
export var arrow = "MobileLinkCarousel-module--arrow--594dd";
export var controls = "MobileLinkCarousel-module--controls--d05a6";
export var linkcarousel = "MobileLinkCarousel-module--linkcarousel--1e8c2";
export var links = "MobileLinkCarousel-module--links--466cd";